
import { mapState, mapMutations, mapGetters } from "vuex";
import ResponsiveDialog from "./responsive-dialog.vue";

export default {
  components: { ResponsiveDialog },
  props: {
    dialog: Boolean
  },

  data() {
    return {
      valid: false,
      items: []
    };
  },
  beforeMount() {
    this.items = JSON.parse(JSON.stringify(this.getItemsWithoutPrice));
  },
  computed: {
    ...mapState("menu", ["menuUploadList"]),
    ...mapGetters("menu", ["getItemsWithoutPrice"])
  },
  methods: {
    ...mapMutations("menu", ["SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP"]),
    handleShowDeleteConfirmationDialog(item) {
      this.$emit("show-delete-confirmation-dialog", item);
    },
    submitSelection() {
      this.items.forEach((element) => {
        const index = this.getMenuUploadItemIndex(
          this.menuUploadList,
          element.id
        );

        if (index !== -1) {
          this.SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP({
            index: index,
            propName: "price",
            propValue: element.price
          });
        }
      });
      this.$emit("proceed-to-next-step");
    }
  }
};
